import getConfig from 'next/config'
import LocalEnv from './env'
import { EnvConfig } from './types'
import { isPrdEnvironment } from '../utils/platform'

const config = getConfig()
const publicRuntimeConfig = (config ? config.publicRuntimeConfig : {}) as EnvConfig

const mergedConfig: EnvConfig = {
  BUGSNAG_APIKEY: publicRuntimeConfig.BUGSNAG_APIKEY || LocalEnv.BUGSNAG_APIKEY,
  ENDPOINT_DOMAIN: publicRuntimeConfig.ENDPOINT_DOMAIN || LocalEnv.ENDPOINT_DOMAIN,
  ENVIRONMENT: publicRuntimeConfig.ENVIRONMENT || LocalEnv.ENVIRONMENT,
  HEADER_ENRICHMENT_DOMAIN: publicRuntimeConfig.HEADER_ENRICHMENT_DOMAIN || LocalEnv.HEADER_ENRICHMENT_DOMAIN,
  HOST: publicRuntimeConfig.HOST || LocalEnv.HOST,
  I18N_DEBUG: publicRuntimeConfig.I18N_DEBUG || LocalEnv.I18N_DEBUG,
  KEYCLOAK_CLIENT_ID: publicRuntimeConfig.KEYCLOAK_CLIENT_ID || LocalEnv.KEYCLOAK_CLIENT_ID,
  KEYCLOAK_DOMAIN: publicRuntimeConfig.KEYCLOAK_DOMAIN || LocalEnv.KEYCLOAK_DOMAIN,
  KONG_APIKEY: publicRuntimeConfig.KONG_APIKEY || LocalEnv.KONG_APIKEY,
  LOCIZE_API_KEY: publicRuntimeConfig.LOCIZE_API_KEY || LocalEnv.LOCIZE_API_KEY,
  LOCIZE_PRIVATE_URL: publicRuntimeConfig.LOCIZE_PRIVATE_URL || LocalEnv.LOCIZE_PRIVATE_URL,
  LOCIZE_PROJECT_ID: publicRuntimeConfig.LOCIZE_PROJECT_ID || LocalEnv.LOCIZE_PROJECT_ID,
}

if (!isPrdEnvironment()) {
  console.log(mergedConfig)
}

export default mergedConfig
